import { gql } from '__generated__';

import useProject from './useProject';
import useQuery from '../api/useQuery';

export const GetParticipantExistsQuery = gql(`
  query GetParticipantExists($project_id: ID!, $email: String!) {
    project(id: $project_id) {
      id
      participant_exists(email: $email)
    }
  }
`);

interface UseParticipantExistenceCheckProps {
  participant: {
    email: string | null;
  },
  enabled?: boolean;
}

const useParticipantExistenceCheck = ({
  participant, enabled = true,
}: UseParticipantExistenceCheckProps) => {
  const project = useProject();

  const skip = !enabled || !participant.email;

  const { data, loading } = useQuery(GetParticipantExistsQuery, {
    variables: {
      project_id: project.id,
      email: participant.email,
    },
    skip,
  });

  const participantExists = !skip && !loading && data?.project.participant_exists;

  return {
    participantExists: !!participantExists,
    loading,
  };
};

export default useParticipantExistenceCheck;
